import { useEffect, useState } from "react"
import { axiosBaseURL } from "../../http"
import { Accordion, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { ToggleHeader } from "../../constants/toggle_header";
import { ContactData } from "./components/contact_data";
import { BaseContainer } from "../../core/base_container";

export const Contacts = () => {

    const [contactTypes, setContactTypes] = useState(null)

    useEffect(() => {
        const getTypes = async () => {
            axiosBaseURL.get('contact_api/contact_types/').then(function (response) {
                setContactTypes(response.data)
            }).catch(function (error) {
                toast.error('Failed to fetch types')
            });
        };

        getTypes();
    }, []);

    return (
        <BaseContainer>
            <Row style={{minHeight:'75vh', marginTop:'5rem'}}>
                {/**overdding scss vars so i dont have the ugly border */}
                <Accordion style={{
                    '--bs-accordion-border-color': 'transparent',
                    '--bs-accordion-bg': 'transparent',
                    '--bs-accordion-btn-focus-box-shadow': 'none',
                }}>
                    {contactTypes ? (
                        <>
                            {
                                contactTypes.map((contact_type, i) => (
                                    <Accordion.Item key={i} eventKey={contact_type.type_value} className="mb-4">
                                        <ToggleHeader eventKey={contact_type.type_value}>{contact_type.type}</ToggleHeader>
                                        <Accordion.Body>
                                            <ContactData type_value={contact_type.type_value} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))
                            }
                        </>
                    ) : (
                        <Row className="justify-content-center">
                            <Spinner variant="primary" />
                        </Row>
                    )}
                </Accordion>
            </Row>
        </BaseContainer>
    )
}